import { Navigate } from 'react-router-dom'

import { Skeleton } from '@/components/feedback/Skeleton'
import { useSession } from '@/features/auth/api/useSession'
import { homeIsDashboard, homePathFor } from '@/lib/navigation'
import { DashboardPage } from '@/routes/DashboardPage'

/* "/" resolves by role (Story 1.4).
 *
 * The dashboard is the founders' and Finance's home. It is not everyone's:
 * its six live figures are the cross-case money view the other three roles
 * may not see, so landing Sales there opens their day on a page of absent
 * tiles. Each role starts where their work is instead.
 *
 * Roles whose home IS the dashboard render it in place rather than being
 * redirected to it — "/" redirecting to "/" is a loop.
 */
export function HomeRoute() {
  const { data: user, isPending } = useSession()

  /* RequireSession has already established there is a session, but its data can
     still be in flight on a hard load. Redirecting on an absent user would send
     everyone to the Sales home for a frame and then move them, so this waits. */
  if (isPending || !user) {
    return <Skeleton className="h-64 rounded-[var(--radius-DEFAULT)]" />
  }

  if (homeIsDashboard(user.role)) {
    return <DashboardPage />
  }

  // replace, so the back button leaves the application rather than returning to
  // a "/" that immediately bounces forward again.
  return <Navigate to={homePathFor(user.role)} replace />
}
